import React from 'react';
import { Box, Grid, Button, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import FormInput from '../../shared/form/FormInput';
import { UserMachineAccessContext } from '../../adminUsers/contexts/UserMachineAccessContext';
import { CompanyAccessContext } from '../contexts/CompanyAccessContext';
import UserMachineAccessForm from '../../shared/form/UserMachineAccessForm';

interface AssignMachineAccessProps {
  company: any;
  machines: any;
  setMachines: any;
}

const AssignMachineAccess: React.FC<AssignMachineAccessProps> = (props) => {
  const { company, machines, setMachines } = props;

  const history = useHistory();

  const [value, setValue] = React.useState(0);
  const [externalEmail, setExternalEmail] = React.useState('');
  const [showAccessFormCompanyUsers, setShowAccessFormCompanyUsers] = React.useState(false);
  const [filteredMachineAccessOptions, setFilteredMachineAccessOptions] = React.useState<Record<string, string>[]>([]);

  const { userMachineAccessOptions } = React.useContext(UserMachineAccessContext);
  const { createBulkCompanyAssignment, companySubmitting } = React.useContext(CompanyAccessContext);

  React.useEffect(() => {
    setFilteredMachineAccessOptions(userMachineAccessOptions?.machine_options);
  }, [userMachineAccessOptions, setFilteredMachineAccessOptions]);

  const handleUpdate = () => {
    createBulkCompanyAssignment({ company_id: company.company_id, machine_ids: machines });
  };

  return !company?.company_id ? (
    <Box sx={{ display: 'inline-block', width: '100%', textAlign: 'center', marginTop: 25 }}>
      <h2 style={{ fontSize: '18px' }}>Loading form...</h2>
      <br />
      <CircularProgress />
    </Box>
  ) : (
    <>
      <Grid container>
        <Grid item md={6} xs={12}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography variant="h2" component="h2">
                Assign Machines to Company
              </Typography>
            </Grid>
          </Grid>
          <UserMachineAccessForm
            label="Machines"
            loading={false}
            pluralLabel="Machines"
            allChoices={userMachineAccessOptions?.machine_options || []}
            choices={userMachineAccessOptions?.machine_options || []}
            setValue={(value) => {
              setMachines([].concat(value));
            }}
            value={machines as string[]}
            initialValue={machines || company?.associated_machines?.map((machine) => machine?.machine_id)}
          />
          <Button variant="contained" color="primary" onClick={handleUpdate}>
            {companySubmitting ? 'Saving...' : 'Assign Machines'}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default AssignMachineAccess;
